// extracted by mini-css-extract-plugin
export var root = "KXG1";
export var rootTooltip = "TDBw";